import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-results-summary-save-dialog',
  templateUrl: './results-summary-save-dialog.component.html',
  styleUrls: ['./results-summary-save-dialog.component.scss']
})
export class ResultsSummarySaveDialogComponent extends UserpilotReloader implements OnInit {

  saveInputs = {
    format: '',
    title: '',
    author: '',
    inputs: false,
    outputs: false,
    outputsYearly: false,
    cashFlow: false,
    pfd: false
  };

  page: string;
  category: string;
  showCashFlow = false;

  /** trigger for translation pipe */
  trigger: string;

  constructor(
    public dialog: MatDialogRef<ResultsSummarySaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogConfig
  ) {
    super();
    this.page = dialogConfig.page;
    this.category = dialogConfig.category;
    this.showCashFlow = dialogConfig.showCashFlow
  }

  ngOnInit(): void { }

  onCancelClick() {
    this.dialog.close();
  }

  onSaveClick() {
    this.dialog.close(this.saveInputs);
  }

  reportIsEmpty() {
    return !this.saveInputs.inputs && !this.saveInputs.outputs && !this.saveInputs.cashFlow && !this.saveInputs.pfd && !this.saveInputs.outputsYearly;
  }

}
